import { isGroup, isRow } from "./sections";
import type { Block, Column, EmailDocument, Group, Row } from "./types";

export type BlockRef = {
  block: Block;
  rowId: string;
  columnId: string;
  row: Row;
  column: Column;
  group?: Group;
};

export function forEachBlock(
  document: EmailDocument,
  visit: (ref: BlockRef) => void,
): void {
  for (const section of document.sections) {
    if (isGroup(section)) {
      for (const row of section.rows) {
        visitRowBlocks(row, section, visit);
      }
      continue;
    }

    if (isRow(section)) {
      visitRowBlocks(section, undefined, visit);
    }
  }
}

export function buildEmailDocumentBlockOrderIndex(
  document: EmailDocument,
): Map<string, number> {
  const order = new Map<string, number>();
  let index = 0;

  forEachBlock(document, ({ block }) => {
    if (!order.has(block.id)) {
      order.set(block.id, index);
      index += 1;
    }
  });

  return order;
}

function visitRowBlocks(
  row: Row,
  group: Group | undefined,
  visit: (ref: BlockRef) => void,
): void {
  for (const column of row.columns) {
    for (const block of column.blocks) {
      visit({
        block,
        rowId: row.id,
        columnId: column.id,
        row,
        column,
        group,
      });
    }
  }
}
